<template lang="pug">
  div.upper-subpanel--inside
    div.col-6
      DrugInfo
    div.col-6
      ConfirmFlow(
        v-if="currentProgress === 'confirm'"
        :confirmProgress="confirmProgress"
        :actionProgress="actionProgress"
        :schedules="schedules"
        :summarySelectedMed="summarySelectedMed"
        v-on:confirmationFinish="getConfirmData"
      )
      Loader(v-if="currentProgress === 'finish'")

</template>

<script>
import _ from 'lodash';
import DrugInfo from '../flowComp/DrugInfo';
import ConfirmFlow from './ConfirmFlow';
import Loader from '../common/Loader';
import MultiFlowBase from '../ComponentBase/MultiFlowBase';


export default {
  name: 'multiflow',
  extends: MultiFlowBase,
  props: ['schedules', 'summarySelectedMed'],
  data() {
    return {
      checkFun: undefined,
    };
  },
  components: {
    DrugInfo,
    ConfirmFlow,
    Loader,
  },
  async created() {
    await this.$store.dispatch('fromFirstDrug');
  },
  computed: {
  },
  methods: {
    getConfirmData() {
      this.nextProgress();
      this.checkFun = setInterval(() => {
        this.checkDevicesCloseAndEmit();
      }, 500);
    },
    nextStep() {
      this.$store.commit('SET_APP_CANCEL_STATUS', true);
      if (this.nextDrug === null) {
        this.$emit('setAllConfirmData');
      } else {
        this.$store.dispatch('toNextDrug');
        setTimeout(() => {
          this.resetProgress();
        }, 100);
      }
    },
    //20190412 modified by aaron
    checkDevicesCloseAndEmit() {
      if (this.nextDevice) {
        if (this.nextDevice.net.id === this.currentDevice.net.id && this.errorDevices.length > 1) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒',
          });
        } else if (this.nextDevice.net.id !== this.currentDevice.net.id && this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜',
          });
        } else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      } else {
        /*
        this.$store.commit('CLOSE_MESSAGE');
        if (this.checkFun) {
          clearInterval(this.checkFun);
        }
        this.nextStep();
        */
        if (this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜',
          });
        } 
        else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// MultiFlow.vue?653bb2f6